module.exports = __webpack_public_path__ + "img/52800.6806f4df.jpg";